export const routes = [
    ...require('./auth').default,
    ...require('./apply-now').default,
    ...require('./home-buy-sell').default,
    ...require('./home-sell').default,
    ...require('./home-buying').default,
    ...require('./refinance').default,
    ...require('./profile').default
];
